let intervals = JSON.parse(localStorage.getItem("intervals") || "{}");
let printNum = JSON.parse(localStorage.getItem("printNum") || "{}");
let drawer = JSON.parse(localStorage.getItem("selectedDrawer") || "{}");

const state = {
  selectedIntervals: intervals,
  selectedPrintNum: printNum,
  selectedPrinters: {
    openAccount: null
  },
  selectedDrawer: drawer
};

const mutations = {
  setIntervals: (state, payload) => {
    state.selectedIntervals = payload;
    localStorage.setItem("intervals", JSON.stringify(state.selectedIntervals));
  },
  setPrintNum: (state, payload) => {
    state.selectedPrintNum = payload;
    localStorage.setItem("printNum", JSON.stringify(state.selectedPrintNum));
  },
  setSelectedPrinters(state, val) {
    for (const [key, value] of Object.entries(val)) {
      state.selectedPrinters[key] = value;
    }
  },
  setSelectedDrawer: (state, payload) => {
    state.selectedDrawer = payload;
    localStorage.setItem(
      "selectedDrawer",
      JSON.stringify(state.selectedDrawer)
    );
  }
};

const actions = {
  setIntervals({ commit, state }, payload) {
    commit(
      "setIntervals",
      Object.assign(
        {
          ...state.selectedIntervals
        },
        payload
      )
    );
  },
  setPrintNum({ commit, state }, payload) {
    commit(
      "setPrintNum",
      Object.assign(
        {
          ...state.selectedPrintNum
        },
        payload
      )
    );
  }
};

const getters = {
  intervals: state => {
    return state.selectedIntervals;
  },
  printNums: state => {
    return state.selectedPrintNum;
  },
  selectedPrinters: state => {
    return state.selectedPrinters;
  },
  selectedDrawer: state => {
    return state.selectedDrawer;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
